import { ConfigureProps } from "react-instantsearch";
import { FilterItemSortingStrategy } from "./types";

export const FACET_TOOLTIP_KEYS = [
  "aiLanguages.translationLanguages",
  "ai_languages.translation_languages",
  "language",
] as const;

export const MIN_ITEMS_TO_SHOW_SEARCH_FILTER = 25;
export const CARDS_PER_PAGE = 24;
export const CARDS_PER_ROW = 3;
export const CARDS_PER_ROW_HORIZONTAL_FILTER_PAGE = 4;
export const PRE_QUERY = "pre-query";
export const ALL_AVAILABLE_FACETS = [
  "availability",
  "level",
  "language",
  "aiLanguages.translationLanguages",
  "ai_languages.translation_languages",
  "partner",
  "program_type",
  "learning_type",
  "skills.skill",
  "skillsData.skill",
  "subject",
  "attributes",
  "productType",
];
export const CUSTOM_ORDERED_STRATEGY_PER_FACET: {
  [key: string]: FilterItemSortingStrategy;
} = {
  "skills.skill": "count",
  "skillsData.skill": "count",
  subject: "count",
  attributes: "count",
  level: "levelPriority",
  availability: "availabilityPriority",
};
export const RESULT_TYPE_NONE = "none";
export const RESULT_TYPE_COURSE = "course";
export const RESULT_TYPE_PROGRAM = "program";
export const RESULT_TYPE_EXECUTIVE_EDUCATION = "executive-education";
export const RESULT_TYPE_BOOT_CAMP = "boot-camp";
export const RESULT_TYPE_DEGREE_PROGRAM = "degree-program";
export const DURATION_WEEK_RANGE = "week_range";
export const RESULT_TYPES = [
  RESULT_TYPE_COURSE,
  RESULT_TYPE_PROGRAM,
  RESULT_TYPE_BOOT_CAMP,
  RESULT_TYPE_DEGREE_PROGRAM,
  RESULT_TYPE_EXECUTIVE_EDUCATION,
  DURATION_WEEK_RANGE,
];
export const COURSE = "Course";
export const PROGRAM = "Program";
export const EXECUTIVE_EDUCATION = "Executive Education";
export const TWOU_DEGREE = "2U Degree";

export const PRODUCT_TYPES = [
  COURSE,
  PROGRAM,
  EXECUTIVE_EDUCATION,
  TWOU_DEGREE,
];

export const PRODUCT_TYPE_KEYS = [
  COURSE,
  PROGRAM,
  EXECUTIVE_EDUCATION,
  TWOU_DEGREE,
] as const;

export const PRODUCT_TYPES_TO_SHOW = [
  PROGRAM,
  COURSE,
  EXECUTIVE_EDUCATION,
  TWOU_DEGREE,
];

export const PRODUCT_TO_RESULT_TYPE_MAP: { [key: string]: string } = {
  [COURSE]: RESULT_TYPE_COURSE,
  [PROGRAM]: RESULT_TYPE_PROGRAM,
  [EXECUTIVE_EDUCATION]: RESULT_TYPE_EXECUTIVE_EDUCATION,
  [TWOU_DEGREE]: RESULT_TYPE_DEGREE_PROGRAM,
  [DURATION_WEEK_RANGE]: DURATION_WEEK_RANGE,
};

export const RESULT_PRODUCT_TYPE_MAP: { [key: string]: string } = {
  [RESULT_TYPE_COURSE]: COURSE,
  [RESULT_TYPE_PROGRAM]: PROGRAM,
  [RESULT_TYPE_EXECUTIVE_EDUCATION]: EXECUTIVE_EDUCATION,
  [RESULT_TYPE_DEGREE_PROGRAM]: TWOU_DEGREE,
  [DURATION_WEEK_RANGE]: DURATION_WEEK_RANGE,
};

export const DEFAULT_SEARCH_CONFIG: ConfigureProps = {
  hitsPerPage: CARDS_PER_PAGE,
  disjunctiveFacets: ALL_AVAILABLE_FACETS,
  facets: ["product"],
  clickAnalytics: true,
  optionalFilters: [
    `product:"${PROGRAM}"<score=1>`,
    `product:"${TWOU_DEGREE}"<score=1>`,
  ],
};

export const QUERY_URL_PARAM = "q";
export const RESULT_TYPE_URL_PARAM = "tab";
export const RESULT_PAGE_URL_PARAM = "page";
export const SORT_URL_PARAM = "sort";
export const SEARCH_SORT_VALUES = [
  "relevance",
  "newest",
  "highest_rated",
] as const;

export const FILTER_CATEGORIES = [
  "attributes",
  "subject",
  "skills.skill",
  "skillsData.skill",
  "partner",
  "productType",
  "learning_type",
  "language",
  "level",
  "aiLanguages.translationLanguages",
  "ai_languages.translation_languages",
  "availability",
];

export const FILTER_CATEGORY_KEYS = [
  "subject",
  "skills.skill",
  "skillsData.skill",
  "partner",
  "learning_type",
  "level",
  "language",
  "aiLanguages.translationLanguages",
  "ai_languages.translation_languages",
  "availability",
  "attributes",
  "productType",
] as const;

export const REFINEMENT_EXCLUDED_ATTRIBUTES = ["query", "product"];

export const LEARNING_TYPE_SUBTITLE_KEYS = [
  "Course",
  "Executive Education",
  "Masters",
  "Bachelors",
  "MicroMasters",
  "MicroBachelors",
  "Doctorate",
  "Professional Certificate",
  "XSeries",
] as const;

export const VALID_SEARCH_URL_PARAMS = [
  QUERY_URL_PARAM,
  RESULT_TYPE_URL_PARAM,
  ...FILTER_CATEGORIES,
  SORT_URL_PARAM,
];

export const PLACEHOLDER_FILTER_COUNT = 7;
export const PLACEHOLDER_CARD_COUNT = 6;
export const FACET_FETCH_LIMIT = 100;
export const FACET_SHOW_LIMIT = 4;

export const MULTI_LOB_SEARCH_PAGE_TYPE = "multi-lob";
export const SINGLE_LOB_SEARCH_PAGE_TYPE = "lob-specific";

export const LEVEL_PRIORITY = ["Introductory", "Intermediate", "Advanced"];
export const AVAILABILITY_PRIORITY = [
  "Current",
  "Available now",
  "Upcoming",
  "Archived",
];

export const DEFAULT_SEARCH_BASE_PATH = "/search";

export const DEFAULT_SECTIONS_ORDER = [
  {
    section: "Lines of business module",
  },
];
